<mat-toolbar class="toolbar">
  <button mat-mini-fab class="fab-compact" (click)="openQuickCreate()" aria-label="Create quickly">
    <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
  </button>

  <div style="display: flex; flex: 1; justify-content: flex-start; align-items: center">
    <button mat-icon-button (click)="previousDay()" aria-label="Jour précédent">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="ff-compact">
      <input matInput [matDatepicker]="picker" [value]="store.currentDate()" (dateChange)="onPick($event.value)" placeholder="jj.mm.aaaa" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker startView="month"></mat-datepicker>
    </mat-form-field>

    <button mat-icon-button (click)="nextDay()" aria-label="Jour suivant">
      <mat-icon>chevron_right</mat-icon>
    </button>

    <button mat-mini-fab class="fab-compact" color="primary" (click)="goToday()" aria-label="Go to today">
      <mat-icon>today</mat-icon>
    </button>
  </div>
</mat-toolbar>

<!-- ====== Nouveau layout: colonne gauche fixe + droite scroll horizontale ====== -->
<div class="board" #boardRoot>
  <!-- --------- Colonne gauche (fixe horizontalement) --------- -->
  <div class="leftPane">
    <!-- En-tête fixe de la colonne gauche -->
    <div class="labelH">Ressource</div>

    <!-- Corps des labels (défilement vertical commun avec la droite via .board) -->
    <div class="labels">
      <!-- ============== AVIONS ============== -->
      <ng-container *ngFor="let a of store.aircrafts()">
        <div class="label" [ngClass]="rowStripeClass(a)" (click)="openAircraft(a)">
          {{ a.code }}
        </div>

        <!-- Placeholder aligné pour la seconde ligne si nécessaire -->
        <div class="label placeholder" *ngIf="reservationsForAircraftSecond(a.id).length" [ngClass]="rowStripeClass(a)" aria-hidden="true"></div>
      </ng-container>

      <!-- Séparateur Instructeurs -->
      <div class="label section-separator" role="separator" aria-label="Séparateur Instructeurs">Instructor</div>

      <!-- ============== INSTRUCTEURS ============== -->
      <ng-container *ngFor="let i of store.instructors()">
        <div class="label">{{ i.user.lastname | uppercase }}</div>

        <div class="label placeholder" *ngIf="reservationsForInstructorSecond(i.id).length" aria-hidden="true"></div>
      </ng-container>
    </div>
  </div>

  <!-- --------- Partie droite (scroll horizontal) --------- -->
  <div class="rightPane">
    <!-- Conteneur unique qui scrolle horizontalement (header + corps) -->
    <div class="hScroller" #sheet>
      <!-- En-tête des heures (sticky en haut du conteneur horizontal) -->
      <div class="headerHours" [style.--hours]="store.hoursCount()" [style.width.px]="timelineWidth()">
        <ng-container *ngFor="let h of store.hoursList()">
          <div class="h" [style.width.px]="hourWidth" *ngIf="h < store.close">
            {{ h }}
          </div>
        </ng-container>
      </div>

      <!-- Corps des timelines -->
      <div class="timelines">
        <!-- ================= AVIONS ================= -->
        <ng-container *ngFor="let a of store.aircrafts()">
          <!-- Ligne primaire -->
          <div class="timeline" [ngClass]="rowStripeClass(a)">
            <div class="inner" #innerA [style.minWidth.px]="timelineWidth()">
              <ng-container *ngFor="let h of store.hoursList()">
                <div class="slot" [style.left.px]="hourLeftPx(h)" *ngIf="h < store.close"></div>
              </ng-container>

              <div
                *ngFor="let r of reservationsForAircraftPrimary(a.id); trackBy: trackResById"
                class="reservation"
                [class.mine]="canEditReservation(r)"
                [class.active]="(store.dragging() && dragState()?.id === r.id) || (store.resizing() && resizeState()?.id === r.id)"
                [style.left.px]="minuteToPx(r.startMin)"
                [style.width.px]="minuteToPx(r.endMin) - minuteToPx(r.startMin)"
                (click)="onReservationClick(r, $event)"
              >
                <div
                  class="resize-handle left"
                  (pointerdown)="onResizePointerDown($event, r, 'start', sheet, innerA)"
                  (click)="$event.stopPropagation()"
                ></div>

                <div class="drag-area" (pointerdown)="onDragPointerDown($event, r, sheet, innerA)">
                  <div class="info" [innerHTML]="displayParticipants(r)"></div>
                </div>

                <button
                  *ngIf="canEditReservation(r)"
                  class="del"
                  type="button"
                  (pointerdown)="squelch($event)"
                  (pointerup)="squelch($event)"
                  (click)="onDeleteClick(r, $event)"
                >
                  ×
                </button>

                <div
                  class="resize-handle right"
                  (pointerdown)="onResizePointerDown($event, r, 'end', sheet, innerA)"
                  (click)="$event.stopPropagation()"
                ></div>
              </div>

              <div
                *ngIf="hasSelectionFor('aircraft', a.id)"
                class="selecting"
                [style.left.px]="minuteToPx(selStart())"
                [style.width.px]="minuteToPx(selEnd()) - minuteToPx(selStart())"
              ></div>

              <!-- couche de capture: création via long-press -->
              <div
                class="capture"
                appCreateGesture
                [rowType]="'aircraft'"
                [rowId]="a.id"
                [open]="store.open"
                [close]="store.close"
                [step]="store.step"
                [hourWidth]="hourWidth"
                [sheetEl]="sheet"
                [tolerateEdgeRebound]="true"
                [clampPointerFn]="clampPointerForCreate.bind(this)"
                (selectBegin)="onSelectBegin($event)"
                (selectChange)="onSelectChange($event)"
                (selectCommit)="onSelectCommit()"
                (selectCancel)="onSelectCancel()"
              ></div>
            </div>
          </div>

          <!-- Ligne secondaire si nécessaire -->
          <div class="timeline secondary" *ngIf="reservationsForAircraftSecond(a.id).length" [ngClass]="rowStripeClass(a)">
            <div class="inner" #innerA2 [style.minWidth.px]="timelineWidth()">
              <ng-container *ngFor="let h of store.hoursList()">
                <div class="slot" [style.left.px]="hourLeftPx(h)" *ngIf="h < store.close"></div>
              </ng-container>

              <div
                *ngFor="let r of reservationsForAircraftSecond(a.id); trackBy: trackResById"
                class="reservation secondary"
                [class.mine]="canEditReservation(r)"
                [class.active]="(store.dragging() && dragState()?.id === r.id) || (store.resizing() && resizeState()?.id === r.id)"
                [style.left.px]="minuteToPx(r.startMin)"
                [style.width.px]="minuteToPx(r.endMin) - minuteToPx(r.startMin)"
                (click)="onReservationClick(r, $event)"
              >
                <div
                  class="resize-handle left"
                  (pointerdown)="onResizePointerDown($event, r, 'start', sheet, innerA2)"
                  (click)="$event.stopPropagation()"
                ></div>

                <div class="drag-area" (pointerdown)="onDragPointerDown($event, r, sheet, innerA2)">
                  <div class="info" [innerHTML]="displayParticipants(r)"></div>
                </div>

                <button
                  *ngIf="canEditReservation(r)"
                  class="del"
                  type="button"
                  (pointerdown)="squelch($event)"
                  (pointerup)="squelch($event)"
                  (click)="onDeleteClick(r, $event)"
                >
                  ×
                </button>

                <div
                  class="resize-handle right"
                  (pointerdown)="onResizePointerDown($event, r, 'end', sheet, innerA2)"
                  (click)="$event.stopPropagation()"
                ></div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Séparateur visuel des timelines -->
        <div class="timeline section-separator" aria-hidden="true"></div>

        <!-- =============== INSTRUCTEURS =============== -->
        <ng-container *ngFor="let i of store.instructors()">
          <!-- Ligne primaire -->
          <div class="timeline">
            <div class="inner" #innerIns [style.minWidth.px]="timelineWidth()">
              <!-- CALQUE DE CASES COLORÉES -->
              <div class="cells">
                <ng-container *ngFor="let h of store.hoursList()">
                  <div
                    *ngIf="h < store.close"
                    class="cell"
                    [style.left.px]="hourLeftPx(h)"
                    [style.width.px]="hourWidth"
                    [ngClass]="availabilityService.availabilityClass(i, h, store.open, store.close, store.step, store.currentDate())"
                  ></div>
                </ng-container>
              </div>

              <ng-container *ngFor="let h of store.hoursList()">
                <div class="slot" [style.left.px]="hourLeftPx(h)" *ngIf="h < store.close"></div>
              </ng-container>

              <div
                *ngFor="let r of reservationsForInstructorPrimary(i.id); trackBy: trackResById"
                class="reservation"
                [class.mine]="canEditReservation(r)"
                [class.active]="(store.dragging() && dragState()?.id === r.id) || (store.resizing() && resizeState()?.id === r.id)"
                [style.left.px]="minuteToPx(r.startMin)"
                [style.width.px]="minuteToPx(r.endMin) - minuteToPx(r.startMin)"
                (click)="onReservationClick(r, $event)"
              >
                <div
                  class="resize-handle left"
                  (pointerdown)="onResizePointerDown($event, r, 'start', sheet, innerIns)"
                  (click)="$event.stopPropagation()"
                ></div>

                <div class="drag-area" (pointerdown)="onDragPointerDown($event, r, sheet, innerIns)">
                  <div class="info" [innerHTML]="displayParticipants(r)"></div>
                </div>

                <button
                  *ngIf="canEditReservation(r)"
                  class="del"
                  type="button"
                  (pointerdown)="squelch($event)"
                  (pointerup)="squelch($event)"
                  (click)="onDeleteClick(r, $event)"
                >
                  ×
                </button>

                <div
                  class="resize-handle right"
                  (pointerdown)="onResizePointerDown($event, r, 'end', sheet, innerIns)"
                  (click)="$event.stopPropagation()"
                ></div>
              </div>

              <div
                *ngIf="hasSelectionFor('instructor', i.id)"
                class="selecting"
                [style.left.px]="minuteToPx(selStart())"
                [style.width.px]="minuteToPx(selEnd()) - minuteToPx(selStart())"
              ></div>

              <div
                class="capture"
                appCreateGesture
                [rowType]="'instructor'"
                [rowId]="i.id"
                [open]="store.open"
                [close]="store.close"
                [step]="store.step"
                [hourWidth]="hourWidth"
                [sheetEl]="sheet"
                [tolerateEdgeRebound]="true"
                [clampPointerFn]="clampPointerForCreate.bind(this)"
                (selectBegin)="onSelectBegin($event)"
                (selectChange)="onSelectChange($event)"
                (selectCommit)="onSelectCommit()"
                (selectCancel)="onSelectCancel()"
              ></div>
            </div>
          </div>

          <!-- Ligne secondaire si nécessaire -->
          <div class="timeline secondary" *ngIf="reservationsForInstructorSecond(i.id).length">
            <div class="inner" #innerIns2 [style.minWidth.px]="timelineWidth()">
              <ng-container *ngFor="let h of store.hoursList()">
                <div class="slot" [style.left.px]="hourLeftPx(h)" *ngIf="h < store.close"></div>
              </ng-container>

              <div
                *ngFor="let r of reservationsForInstructorSecond(i.id); trackBy: trackResById"
                class="reservation secondary"
                [class.mine]="canEditReservation(r)"
                [class.active]="(store.dragging() && dragState()?.id === r.id) || (store.resizing() && resizeState()?.id === r.id)"
                [style.left.px]="minuteToPx(r.startMin)"
                [style.width.px]="minuteToPx(r.endMin) - minuteToPx(r.startMin)"
                (click)="onReservationClick(r, $event)"
              >
                <div
                  class="resize-handle left"
                  (pointerdown)="onResizePointerDown($event, r, 'start', sheet, innerIns2)"
                  (click)="$event.stopPropagation()"
                ></div>

                <div class="drag-area" (pointerdown)="onDragPointerDown($event, r, sheet, innerIns2)">
                  <div class="info" [innerHTML]="displayParticipants(r)"></div>
                </div>

                <button
                  *ngIf="canEditReservation(r)"
                  class="del"
                  type="button"
                  (pointerdown)="squelch($event)"
                  (pointerup)="squelch($event)"
                  (click)="onDeleteClick(r, $event)"
                >
                  ×
                </button>

                <div
                  class="resize-handle right"
                  (pointerdown)="onResizePointerDown($event, r, 'end', sheet, innerIns2)"
                  (click)="$event.stopPropagation()"
                ></div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
